import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
let modal = document.getElementById('modal');

if (!modal) {
  modal = document.createElement('div');
  modal.setAttribute('id', 'modal');
  document.body.appendChild(modal);
}

class ModalRoot extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    this.element = document.createElement('div');
  }

  componentDidMount() {
    modal.appendChild(this.element);
  }

  componentWillUnmount() {
    modal.removeChild(this.element);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.element);
  }
}

export default ModalRoot;
